/**
 * Redirect to a specific page
 */
export const redirect = (url) => {
  window.location.href = url;
};
